import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const cwoaddticketSchema = Yup.object().shape({
    washlocation: Yup.string()
        .required(CommonMessages.location_required)
        .notOneOf(['0'], CommonMessages.paymentType_required),
    subject: Yup.string().required(CommonMessages.subject_required),
    message: Yup.string().required(CommonMessages.message_required),
})